const PROD_CTR_BASE = process.env.VUE_APP_PRODUCT_API;
const PROD_CTR_API = `${process.env.NODE_ENV==='production'?PROD_CTR_BASE:''}/open/api`;
export const JINDUO = {
  WEBSITE: `https://www.jinduo.com`,
  RESOURCE: `https://resource.jinduo.com`,
  UPLOAD: `https://upload.jinduo.com`,
  PROD_CTR_BASE, PROD_CTR_API,
  BRAND_ID: 6,
}